import axios from '@/util/request';

export function GetList(parameter) {
  return axios({
    url: '/ims/mechanism/page',
    method: 'post',
    data: parameter,
  })
}

export function addCompany(parameter) {
  return axios({
    url: '/ims/mechanism/add',
    method: 'post',
    data: parameter,
  })
}

export function updateCompany(parameter) {
  return axios({
    url: '/ims/mechanism/update',
    method: 'put',
    data: parameter,
  })
}

export function delCompany(parameter) {
  return axios({
    url: '/ims/Mechanism/CreateAsysnc',
    method: 'post',
    params: parameter,
  })
}



// WEBPACK FOOTER //
// ./src/api/mechanismMana.js